module.exports = {
  applyTo: require('./applyTo'),
  compose2: require('./compose2'),
  composeB: require('./composeB'),
  constant: require('./constant'),
  converge: require('./converge'),
  flip: require('./flip'),
  identity: require('./identity'),
  psi: require('./psi'),
  substitution: require('./substitution')
}
